import type { Article, SiloId } from '../../types/blog';

import pcLentWindows from './articles/pc-lent-windows-10-11';
import demarrageLent from './articles/demarrage-lent-windows';
import pcQuiChauffe from './articles/pc-qui-chauffe';
import disqueDurSature from './articles/disque-dur-sature';
import virusMalware from './articles/virus-malware-ordinateur';
import publicitesPopups from './articles/publicites-popups-intempestifs';
import erreursWindows from './articles/erreurs-windows-frequentes';
import internetLent from './articles/internet-lent-instable';
import wifiNeFonctionne from './articles/wifi-ne-fonctionne-plus';
import ordinateurNeDemarre from './articles/ordinateur-ne-demarre-plus';
import ecranBleu from './articles/ecran-bleu-bsod';
import miseAJourBloquee from './articles/mise-a-jour-windows-bloquee';
import pcBloquesDemarrage from './articles/pc-bloque-demarrage-windows';
import motDePasseOublie from './articles/mot-de-passe-windows-oublie';
import imprimanteNonDetectee from './articles/imprimante-non-detectee';
import webcamMicro from './articles/webcam-micro-ne-fonctionne-pas';
import pasDeSon from './articles/pas-de-son-ordinateur';
import logicielPlante from './articles/logiciel-plante-ne-souvre-pas';
import recupererFichiers from './articles/recuperer-fichiers-supprimes';
import problemeOutlookGmail from './articles/probleme-outlook-gmail';
import informatiqueSeniors from './articles/informatique-seniors-utiliser-ordinateur-serenite';
import informatiqueTpePme from './articles/informatique-tpe-pme-support-indispensable';
import applicationsWebM365GoogleWorkspace from './articles/applications-web-m365-google-workspace';
import ecranTelephoneCasse from './articles/ecran-telephone-casse';
import batterieTelephoneSeDechargeVite from './articles/batterie-telephone-se-decharge-vite';
import telephoneNeSAllumePlus from './articles/telephone-ne-s-allume-plus';
import telephoneNeChargePlus from './articles/telephone-ne-charge-plus';
import telephoneTombeDansEau from './articles/telephone-tombe-dans-eau';
import vitreDosTelephoneCasse from './articles/vitre-dos-telephone-casse';
import telephoneLentQuiRame from './articles/telephone-lent-qui-rame';
import stockageTelephoneSature from './articles/stockage-telephone-sature';
import hautParleurTelephoneDefaillant from './articles/haut-parleur-telephone-defaillant';
import microTelephoneNeFonctionnePlus from './articles/micro-telephone-ne-fonctionne-plus';
import appareilPhotoCameraTelephoneEnPanne from './articles/appareil-photo-camera-telephone-en-panne';
import boutonPowerVolumeBloque from './articles/bouton-power-volume-bloque';
import wifiBluetoothTelephoneNeSeConnectePlus from './articles/wifi-bluetooth-telephone-ne-se-connecte-plus';
import telephoneQuiSurchauffe from './articles/telephone-qui-surchauffe';
import telephoneRedemarreEnBoucle from './articles/telephone-redemarre-en-boucle';
import prixSiteInternetAutoEntrepreneur from './articles/prix-site-internet-auto-entrepreneur';
import wixOuProfessionnelSiteInternet from './articles/wix-ou-professionnel-site-internet';
import ficheGoogleOuSiteInternet from './articles/fiche-google-ou-site-internet';

export const ARTICLES: Article[] = [
  pcLentWindows,
  demarrageLent,
  pcQuiChauffe,
  disqueDurSature,
  virusMalware,
  publicitesPopups,
  erreursWindows,
  internetLent,
  wifiNeFonctionne,
  ordinateurNeDemarre,
  ecranBleu,
  miseAJourBloquee,
  pcBloquesDemarrage,
  motDePasseOublie,
  imprimanteNonDetectee,
  webcamMicro,
  pasDeSon,
  logicielPlante,
  recupererFichiers,
  problemeOutlookGmail,
  informatiqueSeniors,
  informatiqueTpePme,
  applicationsWebM365GoogleWorkspace,
  ecranTelephoneCasse,
  batterieTelephoneSeDechargeVite,
  telephoneNeSAllumePlus,
  telephoneNeChargePlus,
  telephoneTombeDansEau,
  vitreDosTelephoneCasse,
  telephoneLentQuiRame,
  stockageTelephoneSature,
  hautParleurTelephoneDefaillant,
  microTelephoneNeFonctionnePlus,
  appareilPhotoCameraTelephoneEnPanne,
  boutonPowerVolumeBloque,
  wifiBluetoothTelephoneNeSeConnectePlus,
  telephoneQuiSurchauffe,
  telephoneRedemarreEnBoucle,
  prixSiteInternetAutoEntrepreneur,
  wixOuProfessionnelSiteInternet,
  ficheGoogleOuSiteInternet,
];

export function getArticleBySlug(slug: string): Article | undefined {
  return ARTICLES.find((a) => a.slug === slug);
}

export function getArticlesBySilo(silo: SiloId): Article[] {
  return getAllArticles().filter((a) => a.silo === silo);
}

export function getRelatedArticles(article: Article): Article[] {
  return article.relatedSlugs
    .map((slug) => getArticleBySlug(slug))
    .filter((a): a is Article => a !== undefined);
}

export function getAllArticles(): Article[] {
  return [...ARTICLES].sort(
    (a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime(),
  );
}

export function getPillarArticles(): Article[] {
  return getAllArticles().filter((a) => a.isPillar === true);
}
